module.exports = __webpack_public_path__ + "img/bg_self_service_meal.b8efc1cd.png";